import React from 'react';
import { movdTokens } from './movdTokens.js';

// A labelled group of related fields within a journey stage. Keeps caption
// typography/spacing consistent instead of every stage hand-rolling its own.
export default function MovdFormSection({ label, children, style }) {
  return (
    <div style={{ display: 'grid', gap: 10, ...style }}>
      {label && <p style={{ margin: 0, color: movdTokens.color.content.secondary, fontSize: '.72rem', fontWeight: 900, letterSpacing: '.14em', textTransform: 'uppercase' }}>{label}</p>}
      {children}
    </div>
  );
}
